import { CreditCard, Landmark, Users as UsersIcon } from 'lucide-react';

import { useListCardsQuery, useListLoansQuery, useListUsersQuery } from '../../__generated__/graphql/api';
import {
  CARDS_DEFAULT_FILTERS,
  CARDS_DEFAULT_HREF,
  LOANS_DEFAULT_HREF,
  USERS_DEFAULT_FILTERS,
  USERS_DEFAULT_HREF,
} from '../../constants/defaultListFilters';
import { CountTile } from './components/CountTile';
import { RecentUsersCard } from './components/RecentUsersCard';

const COUNT_TILE_VARIABLES = {
  paginationDetailsOnly: true,
  resultsPerPage: 1,
  pageNumber: 1,
};

export const Dashboard = () => {
  const usersResult = useListUsersQuery({ variables: { ...COUNT_TILE_VARIABLES, ...USERS_DEFAULT_FILTERS } });
  const loansResult = useListLoansQuery({ variables: COUNT_TILE_VARIABLES });
  const cardsResult = useListCardsQuery({ variables: { ...COUNT_TILE_VARIABLES, ...CARDS_DEFAULT_FILTERS } });

  return (
    <main className="flex flex-1 flex-col gap-4 p-4 md:p-8">
      <div className="grid grid-cols-1 gap-4 sm:grid-cols-3">
        <CountTile
          label="Users"
          icon={UsersIcon}
          to={USERS_DEFAULT_HREF}
          loading={usersResult.loading}
          error={usersResult.error}
          count={usersResult.data?.listUsers?.pagination?.totalRecords}
        />
        <CountTile
          label="Loans"
          icon={Landmark}
          to={LOANS_DEFAULT_HREF}
          loading={loansResult.loading}
          error={loansResult.error}
          count={loansResult.data?.listLoans?.pagination?.totalRecords}
        />
        <CountTile
          label="Cards"
          icon={CreditCard}
          to={CARDS_DEFAULT_HREF}
          loading={cardsResult.loading}
          error={cardsResult.error}
          count={cardsResult.data?.listCards?.pagination?.totalRecords}
        />
      </div>
      <RecentUsersCard />
    </main>
  );
};
